import Avatar1 from '../../animations/Nito_Lottie_Unfocused.json';
import Avatar2 from '../../animations/Wedge_Lottie_Unfocused.json';
import Avatar3 from '../../animations/Itty_Lottie_Unfocused.json';
import Avatar4 from '../../animations/Glob_Lottie_Unfocused.json';
import AvatarSelected1 from '../../animations/Nito_Lottie_Focused.json';
import AvatarSelected2 from '../../animations/Wedge_Lottie_Focused.json';
import AvatarSelected3 from '../../animations/Itty_Lottie_Focused.json';
import AvatarSelected4 from '../../animations/Glob_Lottie_Focused.json';

const CNitoAvatars = [
    [Avatar1, AvatarSelected1],
    [Avatar2, AvatarSelected2],
    [Avatar3, AvatarSelected3],
    [Avatar4, AvatarSelected4],
];

export default CNitoAvatars;
